import { Injectable } from "@angular/core";
import { FilterCriteriaService, FilterGroupModel, FilterGroupsService } from "../api";
import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";

@Injectable()
export class FilterGroupValidator {
  public filterGroupId: number = 0;
  public filterCriterionIds: number[] = [];

  constructor(
    private filterGroupsService: FilterGroupsService,
    private filterCriteriaService: FilterCriteriaService
  ) {}

  groupCodeUnique = (control: AbstractControl) => {
    return new Promise<ValidationErrors | null>((resolve, reject) => {
      const code = control.value;

      this.filterGroupsService.getFilterGroupByCode(code).subscribe(foundFilterGroup => {
        if (foundFilterGroup && (!this.filterGroupId || this.filterGroupId !== foundFilterGroup.Id)) {
          resolve({'codetaken': foundFilterGroup});
        }
        resolve(null);
      });
    });
  }

  criterionCodesUnique = (form: FormGroup) => {
    return new Promise<ValidationErrors | null>((resolve, reject) => {
      let allCodes: string[] = [];
      let duplicateCodes: string[] = [];
      for (let controlName in form.controls) {
        if (!controlName.startsWith("Criterion")) {
          continue;
        }
        const code = form.get(controlName)?.get('Code')?.value;
        if (!code) {
          continue;
        }
        if (allCodes.includes(code)) {
          if (!duplicateCodes.includes(code)) {
            duplicateCodes.push(code);
          }
        }
        else {
          allCodes.push(code);
        }
      }

      if (duplicateCodes.length > 0) {
        resolve({duplicateCodes});
      }

      if (allCodes.length === 0) {
        resolve(null);
        return;
      }

      this.filterCriteriaService.getFilterCriteriaByCodes(allCodes).subscribe({
        next: (existingCriteria: any) => {
          const conflictingCriteria = this.filterCriterionIds ? existingCriteria.filter(c => !this.filterCriterionIds.includes(c.Id)) : existingCriteria;
          if (conflictingCriteria.length > 0) {
            resolve({criterionCodesTaken: conflictingCriteria.map(c => c.Code)});
          }
          resolve(null);
        },
        error: err => {
          reject(err);
        }
      });
    });
  }
}
